import * as React from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  CircularProgress,
  withStyles,
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core';

const styles: StyleRulesCallback = t => ({
  input: {
    marginBottom: 12
  },
  container: {
    width: 400
  }
});

interface Props {
  open: boolean;
  report: any;
  onDismiss: () => void;
}

class DownloadReportDialog extends React.Component<Props & WithStyles> {
  renderDownloadContent() {
    const { report, onDismiss } = this.props;
    return (
      <>
        <DialogTitle>Reporte creado</DialogTitle>
        <DialogActions style={{ width: 400 }}>
          <Button color="default" onClick={onDismiss}>
            Cerrar
          </Button>
          <Button
            color="primary"
            onClick={() => window.open(report.downloadUrl, '_blank')}
          >
            Descargar
          </Button>
        </DialogActions>
      </>
    );
  }

  renderLoadingContent() {
    return (
      <DialogContent style={{ textAlign: 'center' }}>
        <CircularProgress color="primary" size={60} />
      </DialogContent>
    );
  }

  render() {
    const { open, report, onDismiss } = this.props;
    return (
      <Dialog open={open} maxWidth={false} onClose={onDismiss}>
        {report ? this.renderDownloadContent() : this.renderLoadingContent()}
      </Dialog>
    );
  }
}

export default withStyles(styles)(DownloadReportDialog);



// WEBPACK FOOTER //
// ./src/components/DownloadReportDialog.tsx